import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import UserSideBar from "./Components/Sidebar";
import {
   EyeCloseIcon,
   EyeOpenIcon
} from "../../Constant/Index";
const UpdatePasswordTherapist = () => {
    const [passwordStates, setPasswordStates] = useState([]);

    const togglePasswordVisibility = (index) => {
        setPasswordStates((prevStates) => {
            const newStates = [...prevStates];
            newStates[index] = !newStates[index];
            return newStates;
        });
    };
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/therapist/home');
    };
    return (
        <>
            <Header />
            <UniversalBanner heading="My Profile" />
            <section className="profile-main">
                <div className="container">
                    <div className="profile-start">
                        <div className="row">
                            <UserSideBar />
                            <div className="col-lg-9 col-md-8">
                                <div className="profile-box">
                                    <div className="top-heading d-flex gap-4 align-items-center pb-4">
                                        <h3 className="md-heading min-width-fit mb-0">Change Password</h3>
                                        <hr className="w-100" />
                                    </div>
                                    <div className="update-form pt-4">
                                        <form className="form-area" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group password">
                                                        <input type={passwordStates[0] ? 'text' : 'password'} name="" id="" className="form-control" placeholder="Old Password" />
                                                        <button className="show-password bg-transparent" type="button" onClick={() => togglePasswordVisibility(0)}>
                                                            <img src={passwordStates[0] ? EyeCloseIcon : EyeOpenIcon} className="eye-icon" alt="" />
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group password">
                                                        <input type={passwordStates[1] ? 'text' : 'password'} name="" id="" className="form-control" placeholder="New Password" />
                                                        <button className="show-password bg-transparent" type="button" onClick={() => togglePasswordVisibility(1)}>
                                                            <img src={passwordStates[1] ? EyeCloseIcon : EyeOpenIcon} className="eye-icon" alt="" />
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 mb-4">
                                                    <div className="form-group password">
                                                        <input type={passwordStates[2] ? 'text' : 'password'} name="" id="" className="form-control" placeholder="Confirm Password" />
                                                        <button className="show-password bg-transparent" type="button" onClick={() => togglePasswordVisibility(2)}>
                                                            <img src={passwordStates[2] ? EyeCloseIcon : EyeOpenIcon} className="eye-icon" alt="" />
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 mb-4 text-end" >
                                                    <button className="btn" type="submit">Save Password</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
        </>
    )
}
export default UpdatePasswordTherapist;